module.exports = __webpack_public_path__ + "static/media/cartAdd.66dbb23e.svg";